import { constants } from "../../../misc/helpers";
import MainTutorialScenario from "./MainTutorialScenario";

export default class MainTutorialScenarioSteps5And6 {
	constructor(private mainScenario: MainTutorialScenario, private onDone: () => void) {
	}

	public start() {
		this.step5ShowBleedingControlKit();
	}

	step5ShowBleedingControlKit() {
		var context = this;
		context.mainScenario.playSequence('TransitionToUnsafe');
		this.mainScenario.playSequence('DisableBystander');
		context.mainScenario.doStuffIfStepsWereSkipped();
		context.mainScenario.playSound('3', '1', () => {
			context.mainScenario.playSound('3', '2', () => {
				var data = {
					disabled: true,
					onSelectionChanged: (index: number) => {
						if (index === 0) {
							context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BleedingControlKit);
							context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.Feedback);
							context.step6ApplyPressure();
							// context.mainScenario.showTryAgainUI(false, false, () => context.step5ShowBleedingControlKit(), () => context.step6ApplyPressure());
						}
					},
					disableTourniqueteButton: true,
					disablePPEButton: true,

				};
				context.mainScenario.playSound('3', '3', () => {
					data.disabled = false;
					context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedingControlKit, data);
				})
				context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedingControlKit, data);
				context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Open the bleeding control kit and select the pressure dressing.'});
			});
		});
	}

	step6ApplyPressure() {
		var context = this;
		this.mainScenario.playSequence('ApplyPressureSetup', null, () => {
			var timeoutHappened = false;
			// this.gameManager.UiManager.showUi(constants.InGameUINames.LookAtObject, {
					// 	dispatch: this.gameManager.customData.dispatch
					// });
					var timeout: any = null;

					//data start
					var data = {
						disabled: true,
						dispatch: context.mainScenario.gameManager.customData.dispatch,
						onTapAndHold: () => {
							context.mainScenario.playSequence('SetBloodParticlePercentage', {
								zeroPercent: true,
								twentyFivePercent: false,
								fiftyPercent: false,
								seventyFivePercent: false,
								oneHundredPercent: false
							});
							if (!timeoutHappened)
							{
							timeout = setTimeout(() => {
								data.disabled = true;
								context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.ApplyPressure, data);
								context.mainScenario.playSound('3', '6', () => {
									context.mainScenario.playSound('3', '7', () => {
										data.disabled = false;
										context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.ApplyPressure, data);
									});
								});
								timeoutHappened = true;
							}, 4000);
						}
						},
						onReleased: () => {
							if (timeout) {
								clearTimeout(timeout);
								timeout = null;
								//timeoutHappened = true;
							}
							context.mainScenario.playSequence('SetBloodParticlePercentage', {
								zeroPercent: false,
								twentyFivePercent: false,
								fiftyPercent: false,
								seventyFivePercent: false,
								oneHundredPercent: true
							});
						},
						onDone: () => {
							data.disabled = true;
							context.step6AfterApplyPressure();
							context.mainScenario.playSequence('SetBloodParticlePercentage', {
								zeroPercent: true,
								twentyFivePercent: false,
								fiftyPercent: false,
								seventyFivePercent: false,
								oneHundredPercent: false
							}, () => {
								context.mainScenario.playSequence('EnablePressureInVictim');
							});
						}
					};
					//data end

					context.mainScenario.playSound('3', '4', () => {
						context.mainScenario.playSound('3', '5', () => {
							data.disabled = false;
							context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.ApplyPressure, data);

						});
					});
					context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.ApplyPressure, data);
					context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Apply pressure by tapping and holding the tap & hold button. KB: Highlight button, then press and hold the Alt + Z keys.'});
		});
		//this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.LookAtObject, data);

		// context.gameManager.UiManager.showUi(constants.InGameUINames.PauseMenu, {
		// 	timer: {
		// 		dispatch: this.gameManager.customData.dispatch,
		// 		penalized: true,
		// 		timePenaltyInSeconds: 60,
		// 		startTimeInSeconds: 240
		// 	},
		// 	returnToMainMenu: {
		// 		onClick: () => context.showExitToMainMenuConfirmation()
		// 	}
		// });
	}

	private step6AfterApplyPressure() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
			this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.LookAtObjectTutorial, {
				dispatch: context.mainScenario.gameManager.customData.dispatch,
				onDone: () => { }
			});
		context.mainScenario.playSound('3', '8', () => {
			context.mainScenario.playSound('3', '9', () => {
				context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
					title: 'Would you like to try again?',
					correctButton: {
						title: 'Try Again',
						greyedOut: true,
						onClick: () => { }
					},
					incorrectButton: {
						title: 'Next',
						greyedOut: true,
						onClick: () => { }
					}
				});
				context.mainScenario.playSound('3', '10', () => {
					context.mainScenario.playSound('3', '11', () => {
					});
				});
						context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BinaryQuestion);
				context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
					title: 'Would you like to try again?',
					correctButton: {
						title: 'Try Again',
						onClick: () => context.step6Again()
					},
					incorrectButton: {
						title: 'Next',
						onClick: () => context.step6End()
					}
				});
				//context.mainScenario.showTryAgainUI(true, true, () => context.step6ApplyPressure(), () => context.onDone()) //context.step7ShowBleedingControlKit()

	});
});
	}

	private step6End() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		context.mainScenario.playSequence('BackToPressureCam', null, () => {
			context.onDone();
		});
	}

	private step6Again() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		context.mainScenario.playSequence('BackToPressureCam', null, () => {
		this.mainScenario.playSequence('ApplyPressureEnd', null, () => {
			context.step5BShowBleedingControlKit();
		});
	});
	}

	step5BShowBleedingControlKit() {
		var context = this;
		context.mainScenario.doStuffIfStepsWereSkipped();
		context.mainScenario.playSound('3', '1', () => {
			context.mainScenario.playSound('3', '2', () => {
				var data = {
					disabled: true,
					onSelectionChanged: (index: number) => {
						if (index === 0) {
							context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BleedingControlKit);
							context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.Feedback);
							context.step6BApplyPressure();
							// context.mainScenario.showTryAgainUI(false, false, () => context.step5ShowBleedingControlKit(), () => context.step6ApplyPressure());
						}
					},
					disableTourniqueteButton: true,
					disablePPEButton: true,

				};
				context.mainScenario.playSound('3', '3', () => {
					data.disabled = false;
					context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedingControlKit, data);
				})
				context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedingControlKit, data);
				context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Open the bleeding control kit and select the pressure dressing.'});
			});
		});
	}

	step6BApplyPressure() {
		var context = this;
			var timeoutHappened = false;
					var timeout: any = null;

					var data = {
						disabled: true,
						dispatch: context.mainScenario.gameManager.customData.dispatch,
						onTapAndHold: () => {
							context.mainScenario.playSequence('SetBloodParticlePercentage', {
								zeroPercent: true,
								twentyFivePercent: false,
								fiftyPercent: false,
								seventyFivePercent: false,
								oneHundredPercent: false
							});
							if (!timeoutHappened)
							{
							timeout = setTimeout(() => {
								data.disabled = true;
								context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.ApplyPressure, data);
								context.mainScenario.playSound('3', '6', () => {
									context.mainScenario.playSound('3', '7', () => {
										data.disabled = false;
										context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.ApplyPressure, data);
									});
								});
							}, 4000);
							timeoutHappened = true;
						}
						},
						onReleased: () => {
							if (timeout) {
								clearTimeout(timeout);
								timeout = null;
								timeoutHappened = true;
							}
							context.mainScenario.playSequence('SetBloodParticlePercentage', {
								zeroPercent: false,
								twentyFivePercent: false,
								fiftyPercent: false,
								seventyFivePercent: false,
								oneHundredPercent: true
							});
						},
						onDone: () => {
							data.disabled = true;
							context.step6AfterApplyPressure();
							context.mainScenario.playSequence('SetBloodParticlePercentage', {
								zeroPercent: true,
								twentyFivePercent: false,
								fiftyPercent: false,
								seventyFivePercent: false,
								oneHundredPercent: false
							});
						}
					};

					context.mainScenario.playSound('3', '4', () => {
						context.mainScenario.playSound('3', '5', () => {
							data.disabled = false;
							context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.ApplyPressure, data);

						});
					});
					context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.ApplyPressure, data);
					context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Apply pressure by tapping and holding the tap & hold button.'});
	}


}